import React from "react";
import MapChart from "./MapChart";
import './Countries.css';
import '../../App.css';

const countries = {
  Highlightedgreen : ["ETH", "MWI"],
  Highlightedorange : ["DZA", "IND", "PAK", "MAR", "TUN", "ZWE", "TZA", "KEN", "LBN", "IRN", "NPL", "BGD", "IDN", "VNM", "PHL", "MNG", "PNG", "NGA", "GHA", "KGZ", "CMR", "CPV", "TLS"],
  Highlightedyellow : ["BIH", "BWA", "BRA", "CHN", "COL", "FJI", "MYS", "MEX", "NAM", "RUS", "ZAF", "THA", "TUR", "ALB", "LKA", "CUB", "KAZ", "ECU", "CRI"],
  Highlightedpurple : ["AUS", "CHL", "CAN", "HKG", "FIN", "JPN", "NLD", "GRC", "POL", "SGP", "KOR", "ESP", "SWE", "ARE", "GBR", "USA", "URY", "NOR", "PRT", "DNK", "CZE", "ITA"]
};

const Countries = () => {
  return (
    <div id="countries"style={{paddingTop:'1rem',marginBottom:'2rem'}}>
      <div className="CountriesPage reveal" >
        <h1 style={{ textAlign: 'center' }}>Countries</h1>
        <div className="Countries reveal" >
        <MapChart countries={countries}/>
          <div className="numbers">
            <h3 style={{ fontWeight: '900', fontSize: '50px' }}>66</h3>
            <h3>countries</h3>
            <h1>Involved in the SUNRISE Study</h1>
            <ul>
              <li>
                <h2>World Bank GDP</h2>
              </li>
              <li>
                <ul className='level_text high'>
                  <li><p></p></li>
                  <li><h3>HIGH - {countries.Highlightedpurple.length}</h3></li>
                </ul>
              </li>
              <li>
                <ul className='level_text umiddle'>
                  <li><p></p></li>
                  <li><h3>UPPER MIDDLE - {countries.Highlightedyellow.length}</h3></li>
                </ul>
              </li>
              <li>
                <ul className='level_text lmiddle'>
                  <li><p></p></li>
                  <li><h3>LOWER MIDDLE - {countries.Highlightedorange.length}</h3></li>
                </ul>
              </li>
              <li>
                <ul className='level_text low'>
                  <li><p></p></li>
                  <li><h3>LOW - {countries.Highlightedgreen.length}</h3></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countries;
